import React from "react";

const InprogressIcon = () => {
  return (
    <>
      <svg width="22" height="22.022" viewBox="0 0 22 22.022">
        <path
          id="Path_2513"
          data-name="Path 2513"
          d="M14.125,2.03a11.026,11.026,0,0,1,0,21.944V21.769a8.822,8.822,0,0,0,0-17.511Zm-2.205.033V4.269a8.817,8.817,0,0,0-4.3,1.853L6.042,4.489a10.84,10.84,0,0,1,5.878-2.426M4.487,6.044,6.064,7.621a8.822,8.822,0,0,0-1.808,4.3H2.05A10.9,10.9,0,0,1,4.487,6.044M2.061,14.127H4.266a8.824,8.824,0,0,0,1.8,4.3L4.5,20a11.071,11.071,0,0,1-2.437-5.878m5.558,5.922a8.824,8.824,0,0,0,4.3,1.8v2.205a11.021,11.021,0,0,1-5.878-2.492Zm5.4-2.062L8.06,13.024h3.86V8.613h2.205v4.411h3.86Z"
          transform="translate(-2.05 -2.03)"
          fill="#fff"
        />
      </svg>
    </>
  );
};

export default InprogressIcon;
